import { render, staticRenderFns } from "./Vats.vue?vue&type=template&id=309ac900"
import script from "./Vats.vue?vue&type=script&lang=ts"
export * from "./Vats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('309ac900')) {
      api.createRecord('309ac900', component.options)
    } else {
      api.reload('309ac900', component.options)
    }
    module.hot.accept("./Vats.vue?vue&type=template&id=309ac900", function () {
      api.rerender('309ac900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/Vats.vue"
export default component.exports